import React from "react";
import { useNavigate } from "react-router-dom";
import pdfImage from "../../assests/images/pdf.png";
import { getFileNameByPath, isEmptyDash } from "../../constant";

function getAnsFromOptId(response, options) {
    let filterData = options.filter(ele => ele?._id == response?.optionId);
    return filterData[0];
}

function getObjectAns(str) {
    if (isEmptyDash(str)) {
        return "";
    } else {
        let arr = str.split("->");
        let str1 = `${arr[0]} | ${arr[1]}`;
        return str1;
    }
    //    return isEmptyDash(str) ? ["", ""] : str.split("->")
}

function GetVRFDetailsAns(props) {
    let navigate = useNavigate();


    return (
        <div className="">
            {(props?.data?.type == "File") && <>
                <div className="images_react_app">

                    {!(isEmptyDash(props?.data?.response?.answer)) && <div className="vendor_maine_content ">
                        <img src={pdfImage} alt="" /> {getFileNameByPath(props?.data?.response?.answer)}
                    </div>}
                </div>
            </>}

            {(props?.data?.type == "String") && <>
                <div>
                    {props?.data?.response?.answer}
                </div>
            </>}

            {(props?.data?.type == "Dropdown") && <>

                <div className="select_react_user_details">
                    <label class="">
                        Select (Yes/No):
                    </label>
                    <p className="yes_react_detail_listing_vendor">
                        {getAnsFromOptId(props?.data?.response, props?.data?.options)?.optionName}
                    </p>
                </div>
                {/* <div>
                {getAnsFromOptId(props?.data?.response, props?.data?.options)?.optionName}
            </div>             */}
            </>}

            {(props?.data?.type == "MultiField" && props?.data?._id != "65dda2f43e446a7c0e67c9eb") && <>
                <div className="">
                    {props?.data?.child.map((ele, i) => <>


                        {(ele?.type == "Dropdown") && <>
                            <div className="select_react_user_details">
                                <label class="">
                                    Select (Yes/No):
                                </label>
                                <p className="yes_react_detail_listing_vendor">
                                    {getAnsFromOptId(ele?.response, ele?.options)?.optionName}
                                </p>
                            </div>
                        </>}

                        {(ele?.type == "String" && (getAnsFromOptId(props?.data?.child[0]?.response, props?.data?.child[0]?.options)?.optionName == 'Yes')) && <>

                            <div className="select_react_user_details">
                                <label class="mb-1 text-dark">
                                    {ele?.name}:
                                </label>
                                <p className="yes_react_detail_listing_vendor">
                                    {ele?.response?.childAnswer}
                                </p>
                            </div>
                        </>}

                        {(ele?.type == "File") && <>
                            <div className="child-details-gap images_react_app">

                                {!(isEmptyDash(ele?.response?.childAnswer)) && <div className="vendor_maine_content ">
                                    <img src={pdfImage} alt="" /> {getFileNameByPath(ele?.response?.childAnswer)}
                                </div>}
                            </div>
                        </>}

                    </>)}
                </div>
            </>}

        </div>
    );
}

export default GetVRFDetailsAns;
